import i18n from "@/i18n";


export default {
    methods: {
        buildPrototype() {
            let prototype = [
                {
                    name: i18n.t('inactiveMachinesChart.Até 12 horas'),
                    color: '#00A315',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Até 24 horas'),
                    color: '#8BF500',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Até 2 dias'),
                    color: '#FFEB00',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Até 5 dias'),
                    color: '#ffb516',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Até 10 dias'),
                    color: '#ff7d20',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Acima de 10 dias'),
                    color: '#e41700',
                    y: 0
                },
                {
                    name: i18n.t('inactiveMachinesChart.Fora de Operação'),
                    color: '#000',
                    y: 0
                }
            ];

            return prototype
        }
    }
}
